import { createFileRoute } from '@tanstack/react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { api } from '@/api';
import { userRoleOptions, UserUpdateSchema, type User, type UserUpdate } from '@shared/modelTypes/user-types';
import { Button, Heading, Row } from 'ht-sdk/react';
import { SelectField, TextField } from '@/components/forms';
import { router } from '@/main';
import { resolver } from 'ht-sdk/react/forms';
import { Page } from '@/components/dashboard/page';

export const Route = createFileRoute('/dashboard/users/$id')({
	component: RouteComponent,
	loader: async ({ params }) => {
		const res = await api.userGet({ id: params.id });
		return res;
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();
	if (!data.success) {
		return <div>Error loading user</div>;
	}

	return (
		<Page>
			<Heading>Edit User</Heading>
			<UserForm user={data.data} />
		</Page>
	);
}

function UserForm({ user }: { user: User }) {
	const methods = useForm({
		resolver: resolver(UserUpdateSchema),
		defaultValues: user,
	});

	async function onSubmit(data: UserUpdate) {
		console.log('onSubmit', data);

		const res = await api.userUpdateById(data);
		if (!res.success) {
			toast.error(res.message);
			return;
		} else {
			toast.success('User updated successfully');
			console.log('navigating to /dashboard/users');
			router.invalidate();
			router.navigate({ to: '/dashboard/users' });
		}
	}

	return (
		<FormProvider {...methods}>
			<form className="flex flex-col gap-3" onSubmit={methods.handleSubmit(onSubmit)}>
				<TextField type="hidden" name="id" label={null} />
				<Row gap={3}>
					<TextField name="firstName" label="First Name" placeholder="First Name" />
					<TextField name="lastName" label="Last Name" placeholder="Last Name" />
				</Row>
				<SelectField name="role" label="Role" options={userRoleOptions} />
				<Button type="submit">Submit</Button>
			</form>
		</FormProvider>
	);
}
